import type { PrimaryLabelType } from '../types';

export const getPrimaryLabel = (
  isNew: boolean,
  purchasable: boolean,
  salePercentage: number,
): { text: string; type: PrimaryLabelType } | null => {
  if (!purchasable) {
    return {
      text: 'Out of stock',
      type: 'stock',
    };
  }
  if (salePercentage > 0) {
    return {
      text: `${salePercentage}% off`,
      type: 'offer',
    };
  }
  if (isNew) {
    return {
      text: 'New',
      type: 'new',
    };
  }

  return null;
};
